/*!
 * Copyright 2019 Fondazione Bruno Kessler
 * Licensed under the EUPL, Version 1.1 or - as soon they will be approved by the European
 * Commission - subsequent versions of the EUPL (the "Licence"); You may not use this work
 * except in compliance with the Licence.
 *
 * You may obtain a copy of the Licence at:
 * http://ec.europa.eu/idabc/eupl.html
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the Licence is distributed on an "AS IS" basis, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the Licence for the specific language
 * governing permissions and limitations under the Licence.
 */

import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChildren,
} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {ConfigSectionComponent} from "@app/models/components/config-section.component";
import {RegistryContexts} from "@app/models/constants/registry-constants";
import {QUERY_PARAM_DIABETES_WIZARD_CONFIGS} from "@app/models/constants/routing-constants";
import {CommonState} from "@app/store/common/common.state";
import {TpConfigsInfo} from "@doctor-panel-modules/patient-treatment-plan/models/tp-sections-info";
import {TpService} from "@doctor-panel-modules/patient-treatment-plan/services/tp.service";
import {PatientTreatmentPlanBaseState} from "@doctor-panel-modules/patient-treatment-plan/store/patient-treatment-plan-base.state";
import {Select, Store} from "@ngxs/store";
import {TrecApiError, TrecError} from "@trec/api/errors";
import {Observable, Subscription} from "rxjs";

interface Icd9 {
  description: string;
  id: string;
}
@Component({
  selector: "c3-tp-base-page",
  templateUrl: "./tp-base.page.html",
  styleUrls: ["./tp-base.page.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TpBasePage implements OnInit, OnDestroy {
  @Select(PatientTreatmentPlanBaseState.error) error$: Observable<TrecError | TrecApiError | null>;
  @Select(CommonState.patientContext) patientContext$: Observable<RegistryContexts | null>;

  @ViewChildren("configSection")
  configSections: QueryList<ConfigSectionComponent>;

  /**
   * List of config sections to show. If null, all section will be shown.
   */
  wizardSelectedConfigIds: string[] = [];

  currentShownConfigs: TpConfigsInfo | null = null;

  glycaemiaProfile;

  operationsProfile;
  context: string = '';

  private readonly subscr = new Subscription();
  listIcd9: string[] = [];
  icd9List: Icd9[] = [];
  constructor(
    private route: ActivatedRoute,
    protected tpService: TpService,
    private store: Store
  ) { }

  ngOnInit() {
    this.context = this.store.selectSnapshot(CommonState.currentContext) || '';
    this.wizardSelectedConfigIds =
      this.route.snapshot.queryParamMap.getAll(QUERY_PARAM_DIABETES_WIZARD_CONFIGS) || [];
    this.subscr.add(
      this.tpService.getCurrentSubScection("base").subscribe((currConfig) => {
        // const currentContext = this.store.selectSnapshot(CommonState.currentContext);
        // if(currentContext === ParentRegistryContexts.CHIRURGIA ){
        //   if (currConfig) {
        //     this.operationsProfile = {
        //       label: "Operazioni secondo ICD-9",
        //       icon: "information-outline",
        //       description:
        //         "Aggiunta e modifica data operazioni da effettuare.",
        //       route: [{ outlets: { "treatment-plan": "base" } }],
        //       fragment: "anchor-operations",
        //     },
        //     currConfig["operations-profile"] = this.operationsProfile;

        //     this.currentShownConfigs = currConfig;
        //   }
        // }
        const patientContext = this.store.selectSnapshot(CommonState.patientContext);
        if (
          patientContext?.includes(RegistryContexts.DIABETES1) ||
          patientContext?.includes(RegistryContexts.DIABETES2) ||
          patientContext?.includes(RegistryContexts.GESTATIONAL)
        ) {
          if (currConfig) {
            this.glycaemiaProfile = {
              label: "Profilo Glicemico",
              icon: "text-box-outline",
              description: "Imposta i parametri del profilo glicemico.",
              route: [{outlets: {"treatment-plan": "base"}}],
              fragment: "anchor-glycaemia-profile",
            };
            currConfig["glycaemia-profile"] = this.glycaemiaProfile;
          }
        }

        this.currentShownConfigs = currConfig;
      })
    );
  }

  showConfig(configId: string): boolean {
    // Decide whether show the config section if selectedCOnfigIds are present
    // If selectedConfigIds is missing -> always show the config section
    const wizardDecision =
      this.wizardSelectedConfigIds.length > 0
        ? this.wizardSelectedConfigIds.includes(configId)
        : true;
    const curreSetupDecision = !!this.currentShownConfigs?.[configId];

    return wizardDecision && curreSetupDecision;
  }

  ngOnDestroy() {
    this.subscr.unsubscribe();
  }
}
